import { Reducer } from 'react';

import { Actions } from './constants';
import { ActionsType, State } from './types';

const initialState: State = {
  list: [],
  isLoading: false,
  error: undefined,
};

const categoriesReducer: Reducer<State, ActionsType> = (state = initialState, action): State => {
  switch (action.type) {
    case Actions.GET_CATEGORIES_PENDING:
      return {
        ...state,
        isLoading: true,
      };
    case Actions.GET_CATEGORIES_SUCCESS:
      return {
        ...state,
        isLoading: false,
        list: action.payload,
      };
    case Actions.GET_CATEGORIES_ERROR:
      return {
        ...state,
        isLoading: false,
        error: action.payload.message,
      };

    default:
      return state;
  }
};

export default categoriesReducer;
